<script>
  export default {
    data() {
      return {
        list: [
          {
            title: '財務資訊',
            name: 'investor-finance'
          },
          {
            title: '公司治理',
            name: 'investor-companypolicy'
          },
          {
            title: '股東專欄',
            name: 'investor-shareholders'
          },
          {
            title: '利害關係人專區',
            name: 'investor-int'
          },
        ],
      }
    }
  }
</script>
<template>
  <BaseLayout
    :menu-list="list"
    :img="require('@assets/images/investor/index_banner.png')"
    custom-class="isStyleWhite"
  >
    <slot/>
  </BaseLayout>
</template>
<style lang="scss" module>

</style>
